import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerAddress } from 'src/app/models/customer-address';
import { CurrentOrderService } from 'src/app/services/current-order.service';
import { CustomerAddressService } from 'src/app/services/customer-address.service';
import { CustomerService } from 'src/app/services/customer.service';
import { InitializationService } from 'src/app/services/initialization.service';
import { LocaleService } from 'src/app/services/locale.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { AlertDialogComponent } from '../dialogs/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-confirm-address',
  templateUrl: './confirm-address.component.html',
  styleUrls: ['./confirm-address.component.scss']
})
export class ConfirmAddressComponent implements OnInit {
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) 
  {
    $event.returnValue =true;
  }

  constructor(
    private customeraddressservice: CustomerAddressService,
    private navigationservice: NavigationService,
    private initializationservice: InitializationService,
    private route: ActivatedRoute,
    public alertDialog: MatDialog,
    private localeservice:LocaleService,
    private customerservice: CustomerService,
    private currentorderservice: CurrentOrderService,
    private router: Router
    ) { }

  customerAddress:CustomerAddress | undefined;

  locationname = '';
  line1="";
  line2="";

  canPop:boolean = false;

  isLoading = false;
  isError = false;

  ngOnInit(): void 
  {
    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if(!this.initializationservice.checkApp(appname))
    {
      this.initializationservice.reloadApp(appname);

     return;
    }

    this.customerAddress = this.customeraddressservice.getCustomerAddress();

    if(this.customerAddress)
      this.line1 = this.customerAddress.AddressString;
  }

  async confirm()
  {
    if(this.locationname.length > 0 && this.line2.length > 0 && this.customerAddress)
    {
      this.isLoading = true;

      this.customerAddress.setLocationName(this.locationname);

      this.customerAddress.SetLine2(this.line2);

      var result = await this.customerservice.saveCustomerAdress(this.customerAddress);

      if(result === true)
      {
        this.canPop = true;

        var afterto = String(this.route.snapshot.queryParamMap.get('afterto'));

        if(afterto === 'return')
          this.back();

        if(afterto === 'returnandset')
        {
          this.currentorderservice.setAdress(this.customerAddress);

          this.back();
        }

        if(afterto === 'orderbasedata')
        {
          this.currentorderservice.setAdress(this.customerAddress);

          var appname = String(this.route.snapshot.paramMap.get('appname'));
          
          this.router.navigateByUrl('/' + appname + '/orderbasedata', { replaceUrl:true });
        }
      }
      else
        this.isError = true;

      this.isLoading = false;
    }
    else
      this.showWarning();
  }

  tryAgain()
  {
    this.isError = false;

    this.confirm();
  }

  canReturn()
  { 
    if(this.canPop === true)
      return true;

    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if(!this.initializationservice.checkApp(appname))
      return true;

    return new Promise<boolean>((resolve, reject) =>
    {
      let dialogRef = this.alertDialog.open(AlertDialogComponent, {
        height: 'fit-content',
        width: 'fit-content',
        data: 
        { 
          title:this.localeservice.instantTranslation("Dialogs.Alert.ReturnWarning.Title"), 
          detail:this.localeservice.instantTranslation("Dialogs.Alert.ReturnWarning.Detail"), 
          accept:this.localeservice.instantTranslation("Dialogs.Alert.ReturnWarning.Accept"), 
          cancel:this.localeservice.instantTranslation("Dialogs.Alert.ReturnWarning.Cancel")  
        }
      });

      dialogRef.afterClosed().subscribe(result => 
      {
        resolve(result);
      });
    });
  }

  back()
  {
    this.navigationservice.back();
  }

  showWarning()
  {
      this.alertDialog.open(AlertDialogComponent, {
      height: 'fit-content',
      width: 'fit-content',
      data: 
      { 
        title:this.localeservice.instantTranslation("Dialogs.Alert.FormWarning.Title"), 
        detail:this.localeservice.instantTranslation("Dialogs.Alert.FormWarning.Detail"), 
        accept:this.localeservice.instantTranslation("Dialogs.Alert.FormWarning.Accept") 
      }
    });
  }
}
